import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom';
import StepOne from './Steps/StepOne';
import StepTwo from './Steps/StepTwo';
import StepThree from './Steps/StepThree';
import StepFour from './Steps/StepFour';
import { Tab, Row, Col, Nav, Image } from 'react-bootstrap';
import './ShopPage.scss';
import Footer from '../Footer/Footer';
import { useStateValue } from '../utilities/StateProvider';
import { PASO_1, PASO_2, PASO_3, PASO_4, VER_CARRITO } from '../../images/images';
import Cart from './Cart/Cart';

export default function ShopPage() {

    const [ activeTab, setActiveTab ] = useState('paso-1');
    const [ cartTotal, setCartTotal ] = useState(0);
    const [ modal, setModal ] = useState(false);
    const [ { cart, isInterior }, dispatch] = useStateValue();

    const isOfAge = sessionStorage.getItem('ofAge');

    useEffect(() => {
        const savedCart = JSON.parse(sessionStorage.getItem('cart'));

        if (savedCart) {
            dispatch({
                type: 'setCart',
                cart: savedCart
            });
        }
    }, []);

    useEffect(() => {
        const checkCartTotal = () => {

            const newCount = Object.values(cart)
            .map((entry) => ((!isInterior) ? entry.price : entry.priceInterior) * entry.quantity)
            .reduce((acc, curr) => (acc + curr), 0);

            setCartTotal(newCount);
        };

        checkCartTotal();
    });

    const nextTab = (newTab) => () => {
        setActiveTab(newTab)
    }

    if (!isOfAge) {
        return (
            <Redirect to={{pathname: "/warning"}} />
        )
    }

    const openCartModal = () => {
        setModal(true);
    }

    const handleHide = () => {
        setModal(false);
    }

    return (
        <div className="shop-page">
            <div className={`header-image ${(cartTotal > 0) ? 'filled' : ''}`}>
                {
                    (cartTotal > 0) ?
                    <div className="item-quantity">${cartTotal}</div> :
                    null
                }
            </div>
            <Tab.Container activeKey={activeTab}>
                <Row>
                    <Nav className="product-tabs justify-content-center" activeKey={activeTab}>
                        <Col xs={3} md={1}>
                            <Nav.Link eventKey="paso-1" disabled>
                                <Image src={PASO_1} roundedCircle fluid/>
                            </Nav.Link>
                        </Col>
                        <Col xs={3} md={1}>
                            <Nav.Link eventKey="paso-2" disabled>
                                <Image src={PASO_2} roundedCircle fluid/>
                            </Nav.Link>
                        </Col>
                        <Col xs={3} md={1}>
                            <Nav.Link eventKey="paso-3" disabled>
                                <Image src={PASO_3} roundedCircle fluid/>
                            </Nav.Link>
                        </Col>
                        <Col xs={3} md={1}>
                            <Nav.Link eventKey="paso-4" disabled>
                                <Image src={PASO_4} roundedCircle fluid/>
                            </Nav.Link>
                        </Col>
                    </Nav>
                </Row>
                <Tab.Content>
                    <Tab.Pane eventKey="paso-1"><StepOne next={nextTab('paso-2')} /></Tab.Pane>
                    <Tab.Pane eventKey="paso-2"><StepTwo next={nextTab('paso-3')} prev={nextTab('paso-1')} /></Tab.Pane>
                    <Tab.Pane eventKey="paso-3"><StepThree next={nextTab('paso-4')} prev={nextTab('paso-2')} /></Tab.Pane>
                    <Tab.Pane eventKey="paso-4"><StepFour next={nextTab('paso-1')} prev={nextTab('paso-3')} /></Tab.Pane>
                </Tab.Content>
            </Tab.Container>
            <Image src={VER_CARRITO} className="cart-trigger-modal" width={100} height={100} onClick={openCartModal} />
            <Cart show={modal} onHide={handleHide}/>
            <Footer fixed="bottom" page="resume" />
        </div>
    )
}
